import { brandMarkPath } from "../components/common/BrandLockup";
import { Footer } from "../components/common/Footer";

export function ProductHomePage() {
  return (
    <div className="go-beauty">
      <nav className="gb-nav">
        <a className="gb-brand" href="/go" aria-label="THH GO">
          <img className="gb-logo" src={brandMarkPath} alt="" aria-hidden="true" />
          <small>GO</small>
        </a>
        <div className="gb-navlinks">
          <a href="#conceito">Conceito</a>
          <a href="#dores">Dores</a>
          <a href="#verticais">Verticais</a>
          <a href="#trilha" className="gb-navcta">Ver trilha</a>
        </div>
      </nav>

      <section className="gb-hero">
        <div className="gb-hero-copy">
          <p className="gb-eyebrow">Plataforma operacional vertical</p>
          <h1>Uma base para negócios de nicho que já cresceram além do improviso.</h1>
          <p>
            O THH GO nasce para remover fricções da operação e devolver o foco ao que mais importa:
            o cliente. Embora cada vertical tenha suas próprias dores, existe um ponto em comum entre
            elas: quando a rotina exige atenção demais para organização, controle e execução, sobra
            menos tempo para entregar uma experiência melhor. A proposta do THH GO é justamente
            inverter essa lógica: simplificar a operação para ampliar a eficiência e liberar o
            profissional ou a empresa para priorizar o atendimento.
          </p>
          <div className="gb-actions">
            <a className="gb-primary" href="#conceito">Ler a tese</a>
            <a className="gb-secondary" href="/beauty">Beauty já está ativa</a>
          </div>
          <div className="gb-trust">
            <span>Pesquisa de campo antes de interface</span>
            <span>Uma base, múltiplas verticais</span>
            <span>Beauty como primeira prova pública</span>
          </div>
        </div>

        <div className="gb-board" aria-label="Resumo operacional">
          <div className="gb-board-head">
            <div>
              <span>Por que isso existe</span>
              <strong>O mercado tem softwares genéricos demais para dores específicas demais</strong>
            </div>
            <em>em construção</em>
          </div>
          <div className="gb-metrics">
            <div>
              <strong>01</strong>
              <span>núcleo operacional comum</span>
            </div>
            <div>
              <strong>04</strong>
              <span>verticais já mapeadas no desenho</span>
            </div>
            <div>
              <strong>02</strong>
              <span>camadas públicas: conceito e conversão</span>
            </div>
          </div>
          <div className="gb-schedule">
            <div className="gb-slot">
              <time>Padrão</time>
              <div>
                <strong>A operação quebra antes do negócio perceber</strong>
                <span>Agenda falha, cliente se dispersa, a equipe improvisa e a decisão chega tarde.</span>
              </div>
              <em>origem</em>
            </div>
            <div className="gb-slot">
              <time>Resposta</time>
              <div>
                <strong>O produto organiza a rotina como sistema</strong>
                <span>Disponibilidade, histórico, recorrência e atendimento passam a conversar entre si.</span>
              </div>
              <em>produto</em>
            </div>
            <div className="gb-slot">
              <time>Abertura</time>
              <div>
                <strong>Beauty abre a frente pública. As demais vêm depois</strong>
                <span>Não por falta de ambição, mas porque vertical séria precisa de lógica séria.</span>
              </div>
              <em>plataforma</em>
            </div>
          </div>
          <p className="gb-note">
            O THH GO não é uma landing de planos. É a tese de como transformar rotina dispersa em
            operação legível, replicável e verticalizada.
          </p>
        </div>
      </section>

      <section className="gb-strip" id="conceito">
        <article>
          <strong>Categoria antes de feature.</strong>
          <p>O produto nasce de uma leitura de mercado, não de um catálogo de funcionalidades.</p>
        </article>
        <article>
          <strong>Operação antes de estética.</strong>
          <p>Valor real aparece quando o negócio enxerga agenda, cliente, equipe e rotina com clareza.</p>
        </article>
        <article>
          <strong>Vertical antes de generalização.</strong>
          <p>Cada frente abre com contexto, linguagem e proposta próprios, sobre a mesma espinha dorsal.</p>
        </article>
        <article>
          <strong>Escala sem recomeço.</strong>
          <p>A plataforma cresce por especialização sem perder coerência de dados, produto e arquitetura.</p>
        </article>
      </section>

      <section className="gb-section gb-split" id="dores">
        <div>
          <p className="gb-eyebrow">Dores recorrentes</p>
          <h2>As verticais mudam, mas a raiz do problema costuma ser a mesma.</h2>
          <p>
            O THH GO nasce da repetição de um padrão em diferentes nichos: o negócio evolui, mas a
            operação segue fragmentada, dependente de memória, mensagens, planilhas e decisões sem
            estrutura. A plataforma foi criada para organizar essa base antes de se especializar nas
            necessidades de cada vertical.
          </p>
        </div>
        <div className="gb-flow">
          <div className="gb-flow-row">
            <span>01</span>
            <div>
              <strong>Agenda fragmentada</strong>
              <p>Disponibilidade, encaixe, confirmação e remarcação deixam de depender do improviso.</p>
            </div>
          </div>
          <div className="gb-flow-row">
            <span>02</span>
            <div>
              <strong>Cliente invisível para o negócio</strong>
              <p>Histórico, recorrência e relacionamento passam a pertencer à operação, não ao acaso.</p>
            </div>
          </div>
          <div className="gb-flow-row">
            <span>03</span>
            <div>
              <strong>Rotina dependente de memória</strong>
              <p>O time deixa de se apoiar em lembrança, conversa solta e retrabalho manual para funcionar.</p>
            </div>
          </div>
          <div className="gb-flow-row">
            <span>04</span>
            <div>
              <strong>Crescimento sem leitura</strong>
              <p>O negócio ganha sistema para decidir melhor antes de ganhar mais camadas de complexidade.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="gb-section gb-settings">
        <div className="gb-section-head">
          <p className="gb-eyebrow">Pilares da plataforma</p>
          <h2>Uma base integrada para operar, decidir e expandir com consistência.</h2>
          <p>
            O THH GO foi desenhado para combinar profundidade operacional com capacidade de expansão.
            A plataforma parte de um núcleo comum e evolui por verticais com linguagem, regras e
            fluxos próprios.
          </p>
        </div>
        <div className="gb-cards">
          <article className="gb-card">
            <strong>Base integrada</strong>
            <p>Agenda, cliente, recorrência, status e capacidade convivem na mesma estrutura operacional.</p>
          </article>
          <article className="gb-card">
            <strong>Especialização por vertical</strong>
            <p>Cada frente entra com fluxo, termos, regras e propostas aderentes ao seu contexto real.</p>
          </article>
          <article className="gb-card">
            <strong>Dados para decisão</strong>
            <p>A plataforma transforma rotina em leitura operacional, para apoiar decisões com mais contexto.</p>
          </article>
          <article className="gb-card">
            <strong>Governança para crescer</strong>
            <p>O núcleo amadurece com consistência para sustentar novas frentes sem perder clareza nem controle.</p>
          </article>
        </div>
      </section>

      <section className="gb-section gb-pricing" id="verticais">
        <div className="gb-section-head">
          <p className="gb-eyebrow">Verticais mapeadas</p>
          <h2>Cada vertical encontra a plataforma a partir da sua própria rotina.</h2>
          <p>
            O THH GO parte de uma base comum e desce para contextos específicos de operação. Quando
            a rotina faz sentido para a sua vertical, a navegação segue para uma página dedicada,
            com narrativa, proposta e entrada comercial próprias.
          </p>
        </div>
        <div className="gb-price-grid">
          <article className="gb-price-card">
            <span>Beauty</span>
            <h3>Vertical ativa</h3>
            <p>Para operações em que agenda, recorrência, confirmação e relacionamento com clientes fazem parte do dia a dia.</p>
            <ul>
              <li>Agenda, atendimento e histórico no mesmo fluxo</li>
              <li>Fricções visíveis e valor percebido logo no uso inicial</li>
              <li>Página própria focada em conversão da vertical</li>
            </ul>
            <a href="/beauty">É de Beauty? Conheça a vertical</a>
          </article>
          <article className="gb-price-card featured">
            <span>Health e Legal</span>
            <h3>Verticais em aprofundamento</h3>
            <p>Contextos com aderência forte à lógica da plataforma, mas que exigem linguagem, fluxo e governança mais específicos.</p>
            <ul>
              <li>Health pede cadência, histórico e sensibilidade operacional</li>
              <li>Legal pede prazo, carteira, acompanhamento e visibilidade</li>
              <li>Abertura pública só faz sentido com proposta própria</li>
            </ul>
            <a href="/go/start">Quero acompanhar essa evolução</a>
          </article>
          <article className="gb-price-card assisted">
            <span>Oficinas e novas frentes</span>
            <h3>Novos contextos operacionais</h3>
            <p>Outras frentes entram quando a base comum encontra um contexto de uso onde aprofundamento de produto gera valor real.</p>
            <ul>
              <li>Mesma espinha dorsal, leituras específicas por operação</li>
              <li>Expansão sem diluir a consistência da plataforma</li>
              <li>Entrada guiada para quem quer falar cedo com a THH</li>
            </ul>
            <a href="/go/start">Sua vertical faz sentido aqui? Fale com a THH</a>
          </article>
        </div>
      </section>

      <section className="gb-launch" id="trilha">
        <div className="gb-launch-head">
          <p className="gb-eyebrow">Visão da plataforma</p>
          <h2>O THH GO foi desenhado para evoluir com consistência, preservando clareza operacional e profundidade de produto.</h2>
          <p>
            A plataforma combina uma base operacional comum com camadas especializadas para contextos
            distintos de atendimento. Isso permite ampliar capacidade, aprofundar fluxos e adaptar a
            experiência ao longo do tempo, sem perder coerência de dados, governança e continuidade.
          </p>
        </div>
        <div className="gb-launch-grid">
          <article className="gb-launch-card">
            <span className="gb-launch-badge">Base</span>
            <strong>Estrutura operacional integrada</strong>
            <p>
              Agenda, cliente, recorrência, capacidade e acompanhamento convivem em uma mesma lógica
              operacional para reduzir dispersão e aumentar legibilidade.
            </p>
          </article>
          <article className="gb-launch-card active">
            <span className="gb-launch-badge">Especialização</span>
            <strong>Camadas aderentes a cada contexto</strong>
            <p>
              A experiência evolui com fluxos, termos e regras mais aderentes ao contexto de uso,
              sem abandonar a consistência da plataforma.
            </p>
          </article>
          <article className="gb-launch-card">
            <span className="gb-launch-badge">Leitura</span>
            <strong>Dados que apoiam decisão</strong>
            <p>
              A rotina deixa rastros úteis para leitura operacional, ajudando negócios a decidir com
              mais contexto, previsibilidade e controle.
            </p>
          </article>
          <article className="gb-launch-card">
            <span className="gb-launch-badge">Continuidade</span>
            <strong>Crescimento com governança</strong>
            <p>
              O núcleo foi pensado para sustentar evolução contínua, com profundidade operacional,
              disciplina de produto e espaço para novas camadas de sofisticação.
            </p>
          </article>
        </div>
      </section>

      <section className="gb-final">
        <p className="gb-eyebrow">Visão da plataforma</p>
        <h2>O THH GO constrói uma plataforma operacional para verticais que exigem contexto, rigor e continuidade.</h2>
        <p>
          Beauty é a primeira expressão pública dessa estratégia. O que está em construção é uma
          base capaz de sustentar novas frentes com a mesma disciplina de produto, operação e
          evolução de negócio.
        </p>
        <div className="gb-actions">
          <a className="gb-primary" href="/beauty">É de Beauty? Comece por aqui</a>
          <a className="gb-secondary" href="/go/start">Falar com a THH</a>
        </div>
      </section>

      <Footer
        brand="THH GO"
        message="THH — Tese de plataforma operacional para verticais baseadas em atendimento"
        links={[
          { href: "/beauty", label: "Beauty" },
          { href: "/go", label: "THH GO" },
          { href: "/", label: "THH" }
        ]}
      />
    </div>
  );
}
